import { withInstall } from '@chenms-zj/utils/with-install'
import _Tabs from './src/tabs.vue'
import _TabPane from './src/tab-pane.vue'

export const Tabs = withInstall(_Tabs)
export const TabPane = withInstall(_TabPane)

export default Tabs

export { tabsProps } from './src/tabs'
export { tabPaneProps } from './src/tab-pane'

// 声明模块
declare module 'vue' {
  export interface GlobalComponents {
    'cms-tabs': typeof Tabs
    'cms-tab-pane': typeof TabPane
  }
}
